import * as types from './types'



export const fetchWarehousesRequest = () =>{

    return {
        type : types.FETCH_WAREHOUESES_REQUEST
    }

}

export const fetchWarehousesSuccess = (data) =>{

    return {
        type : types.FETCH_WAREHOUESES_SUCCESS,
        payload : data
    }

}

export const fetchWarehousesFailed = (error) =>{

    return {
        type : types.FETCH_WAREHOUESES_REQUEST,
        payload : error
    }

}


export const addWarehouseRequest = () => {
    return {
        type : types.ADD_WAREHOUSE_REQUEST ,
        
    }
}

export const addWarehouseSuccess = () => {
    return {
        type : types.ADD_WAREHOUSE_REQUEST ,       
    }
}

export const addWarehouseFailed = (error) => {
    return {
        type : types.ADD_WAREHOUSE_REQUEST ,
        payload : error
        
    }
}